import axios from 'axios'
import { useContext, useState, useEffect } from 'react'
import urlSearchParams from '../../components/urlSearchParams'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { FeatureContext } from '../../context api/Features/FeatureContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, success, getNewToken } from '../../shared/constants'

export const useAttendance = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const [attendance, setAttendance] = useState(false)
  const [absentEmployee, setAbsentEmployee] = useState(false)
  const [employees, setEmployees] = useState(false)
  const [location, setLocation] = useState(false)
  const [monthlyAbsent, setMonthlyAbsent] = useState(false)
  const [absentMonth, setAbsentMonth] = useState(false)
  const [totalEmployee, setTotalEmployee] = useState(false)
  const [paginate, setPaginate] = useState(false)
  const [attendanceSummary, setAttendanceSummary] = useState(false)
  const [loading, setLoading] = useState(false)
  const [productiveHours, setProductiveHours] = useState(0)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [pdfCsvData, setPdfCsvData] = useState({ headings: [], headingValues: [] })
  const { addNewAttendance, editNewAttendance, deleteNewAttendance, getNewAttendances } = useContext(FeatureContext)
  const [cancelToken, setCancelToken] = useState()

  const { getNewEmployeeAttendances } = useContext(ConfigurationContext)

  useEffect(() => {
    if (cancelToken) {
      setLoading(true)
    }
  }, [cancelToken])

  const downloadKeys = {
    ATTENDANCE: 'ATTENDANCE',
  }

  const downloadAPI = (key) => {
    switch (key) {
      case downloadKeys.ATTENDANCE:
        return API.GET_BELOW_EMPLOYEE_ATTENDANCE
      default:
        return ''
    }
  }

  const getAllAttendance = (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_BELOW_EMPLOYEE_ATTENDANCE(urlSearchParams(dto)), {
        ...header,
        cancelToken: getNewToken(cancelToken, setCancelToken),
      })
      .then(({ status, data }) => {
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        getNewAttendances(data.USR)
        setPaginate(data.paginate)
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getAttendance = async (dto) => {
    setLoading(true)
    axios
      .post(API.GET_ATTENDANCE, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setAttendance(data.data)
        setLoading(false)
        setEmployees(data.data)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getLocationByCoordinates = async (dto) => {
    setLoading(true)
    axios
      .get(API.GET_ADDRESS_BY_COORDINATES(dto.lat, dto.long), header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setLocation(data.data)
        setLoading(false)
        // setAttendances(data.data)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getEmployeeAttendance = async (dto) => {
    setLoading(true)
    axios
      .post(API.GET_ATTENDANCE_OF_EMPLOYEE, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        getNewEmployeeAttendances(data.data)
        // setAttendances(data.data)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getEmployeeAttendanceByPosition = async (dto, setPositionId) => {
    setLoading(true)
    axios
      .post(API.GET_ATTENDANCE_BY_POSITION, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        getNewAttendances(data.data)
        setLoading(false)
        // setAttendances(data.data)
        //setPositionId([])
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getFilterAttendance = async (dto = {}) => {
    setLoading(true)
    let searchParams = new URLSearchParams()
    if (dto.positionId) searchParams.set('positionId', dto.positionId)
    if (dto.status) searchParams.set('status', dto.status)
    let params = searchParams.toString()
    if (params.length) params = '?' + params
    axios
      .get(API.GET_FILTER_ATTENDANCE(params), header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setLoading(false)
        getNewAttendances(data.data)
        // setAttendances(data.data)
        //setPositionId([])
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const addAttendance = (dto) => {
    axios
      .post(API.ADD_ZONE, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Attendance Added Successfully', success)
        addNewAttendance(data.data)
      })
      .catch((err) => {
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteAttendance = (dto, setSelected) => {
    axios
      .post(API.DELETE_ATTENDANCE, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Attendance Deleted Successfully', success)
        // addNewAttendance(data.data)+
        deleteNewAttendance(dto.attendanceId)
        setSelected([])
      })
      .catch((err) => {
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteManyAttendance = (dto, setSelected) => {
    axios
      .post(API.DELETE_MANY_ATTENDANCE, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(`${dto.attendanceId.length} Attendance Deleted Successfully`, success)

        dto.attendanceId.map((item) => deleteNewAttendance(item))
        setSelected([])
      })
      .catch((err) => {
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteEmployeeAttendance = (dto, setSelected) => {
    axios
      .post(API.DELETE_ATTENDANCE, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Attendance Deleted Successfully', success)
        // addNewAttendance(data.data)+
        deleteNewAttendance(dto.attendanceId)
        setSelected([])
      })
      .catch((err) => {
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteEmployeeManyAttendance = (dto, setSelected) => {
    axios
      .post(API.DELETE_MANY_ATTENDANCE, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(`${dto.attendanceId.length} Attendance Deleted Successfully`, success)

        dto.attendanceId.map((item) => deleteNewAttendance(item))
        setSelected([])
      })
      .catch((err) => {
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const BulkUpload = async (dto) => {
    axios
      .post(API.BULK_UPLOAD, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        data.data.map((item) => addNewAttendance(item))
        toastMessage(`${data.data.length} Data Inserted Successfully`, success)
        return getAllAttendance()
      })
      .catch((err) => {
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getAttendanceReportSummary = async (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_ATTENDANCE_SUMMARY(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        console.log({ data })
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setAttendance(data.data)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getAttendanceInTimeReport = async (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_ATTENDANCE_IN_TIME_REPORT(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        } else setAttendance(data.data)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getAttendanceMonthlyLateReport = async (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_ATTENDANCE_MONTHLY_LATE_REPORT(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        } else setAttendance(data.data)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getProductiveTimeReport = async (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_PRODUCTIVE_TIME_REPORT(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        } else setAttendance(data.data)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getTeamLeaseDumpReport = async (dto = {}) => {
    setDownloadLoading(true)
    axios
      .get(API.GET_TEAM_LEASE_DUMP_REPORT(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setDownloadLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPdfCsvData(data)
      })
      .catch((err) => {
        setDownloadLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getPdfCsvData = async (key = '', dto = {}) => {
    setDownloadLoading(true)
    dto = { ...dto, download: 1 }
    axios
      .get(downloadAPI(key)(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setDownloadLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPdfCsvData(data)
      })
      .catch((err) => {
        setDownloadLoading(false)
        if (err.response) {
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  return {
    addAttendance,
    getAllAttendance,
    deleteAttendance,
    getAttendance,
    attendance,
    employees,
    deleteManyAttendance,
    getEmployeeAttendance,
    getEmployeeAttendanceByPosition,
    BulkUpload,
    deleteEmployeeAttendance,
    deleteEmployeeManyAttendance,
    absentEmployee,
    monthlyAbsent,
    absentMonth,
    getAttendanceReportSummary,
    attendanceSummary,
    getAttendanceInTimeReport,
    totalEmployee,
    paginate,
    getFilterAttendance,
    loading,
    getAttendanceMonthlyLateReport,
    getProductiveTimeReport,
    productiveHours,
    getLocationByCoordinates,
    location,
    downloadLoading,
    getTeamLeaseDumpReport,
    getPdfCsvData,
    pdfCsvData,
    downloadKeys,
  }
}
